export default "__VITE_ASSET__1tsN64rX__"